module.exports = __webpack_public_path__ + "static/media/IMG-2.9ae378c1.jpg";